(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 46127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgForosLogoWhite = function SvgForosLogoWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 82 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#foros-logo-white_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.547 2.717v5.602h7.63c0 .888-.734 2.273-1.457 2.326H2.547v7.325C2.484 18.774.975 19.61 0 19.588V.402h11.529c0 .888-.723 2.272-1.447 2.315H2.547ZM43.368 5.994a3.058 3.058 0 0 0-.953-2.611 5.142 5.142 0 0 0-3.081-.72H36v6.85h3.144a7.278 7.278 0 0 0 2.505-.338 2.216 2.216 0 0 0 1.3-1.057c.305-.664.448-1.393.418-2.124Zm.294 12.79-4.35-7.019h-3.311v6.205c-.063.804-1.583 1.639-2.547 1.618V.402h5.91c2.37 0 4.057.444 5.084 1.321a5.014 5.014 0 0 1 1.234 1.862 5.05 5.05 0 0 1 .307 2.218 6.47 6.47 0 0 1-.923 3.71 4.73 4.73 0 0 1-3.05 1.84l1.049 1.617 3.73 5.952v.074l.105.148c-.796.539-2.494.655-2.966 0l-.23-.38-.042.02ZM82 14.345a5.165 5.165 0 0 1-.395 2.287 5.125 5.125 0 0 1-1.355 1.877A7.739 7.739 0 0 1 75.125 20a9.01 9.01 0 0 1-4.287-.919 6.958 6.958 0 0 1-2.809-2.843c1.667-1.184 2.788-.328 2.925-.18l.251.243a5.36 5.36 0 0 0 3.867 1.417 5.206 5.206 0 0 0 3.144-.846c.374-.259.677-.608.88-1.017.204-.409.301-.862.284-1.32a2.555 2.555 0 0 0-.367-1.426 3.338 3.338 0 0 0-.975-.983 5.836 5.836 0 0 0-1.394-.635 23.839 23.839 0 0 0-1.635-.465 56.393 56.393 0 0 1-2.61-.708 8.568 8.568 0 0 1-2.095-.951 4.286 4.286 0 0 1-1.394-1.49 4.738 4.738 0 0 1-.514-2.348 5.252 5.252 0 0 1 .374-2.198 5.213 5.213 0 0 1 1.25-1.84A7.033 7.033 0 0 1 74.937 0a7.681 7.681 0 0 1 4.119.962 7.19 7.19 0 0 1 2.431 2.473c-1.886 1.385-2.725.413-2.997.18l-.094-.095a5.477 5.477 0 0 0-.734-.57 5.08 5.08 0 0 0-2.725-.677 4.52 4.52 0 0 0-2.893.824 2.714 2.714 0 0 0-1.048 2.21c-.014.432.09.86.304 1.236.222.363.537.66.912.856.452.258.935.457 1.436.592l1.96.466c.86.232 1.687.475 2.463.729a7.695 7.695 0 0 1 2.096 1.004c.58.416 1.05.967 1.373 1.607.36.797.52 1.673.461 2.547Z",
    fill: "#fff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M65.483 10.042c0 5.423-3.47 9.694-7.966 9.926h-.398c-.356 0-.66 0-.66-.328v-7.928l-2.494 2.315c-.367-.39-.598-1.321-.294-1.649L56.46 9.81V8.034l-2.211 2.04c-.367-.38-.598-1.31-.294-1.639l2.641-2.378.126-.116a.626.626 0 0 1 .44-.159c.162-.006.32.05.44.159l.126.116 2.568 2.4c.304.327.073 1.257-.294 1.638L57.79 8.034V9.82l2.788 2.569c.304.328.073 1.258-.304 1.649l-2.484-2.315v5.909c3.008-.423 5.356-3.658 5.356-7.59 0-4.228-2.704-7.632-6.027-7.632-3.322 0-6.016 3.425-6.016 7.632a8.816 8.816 0 0 0 1.593 5.17l.063.094a3.972 3.972 0 0 1-.419 2.94 10.47 10.47 0 0 1-2.7-3.697 10.554 10.554 0 0 1-.874-4.507c0-5.57 3.668-9.936 8.385-9.936 4.716 0 8.332 4.365 8.332 9.936Z",
    fill: "#D9B310"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.511 10.042c0 4.229 2.704 7.632 6.027 7.632 3.322 0 6.026-3.425 6.026-7.632S24.86 2.41 21.538 2.41c-3.323 0-6.027 3.425-6.027 7.632Zm14.38 0c0 5.582-3.669 9.947-8.385 9.947-4.716 0-8.384-4.365-8.384-9.947 0-5.581 3.668-9.936 8.384-9.936s8.384 4.365 8.384 9.936Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "foros-logo-white_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h82v20H0z"
  })))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgForosLogoWhite);

/***/ }),

/***/ 98402:
/***/ (function(module) {

module.exports = "/_next/static/videos/trees-about-bb00209c55175bd74797d35cb018c15d.mp4";

/***/ }),

/***/ 2802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(69325);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AboutUs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-collapse/lib/index.js
var lib = __webpack_require__(98452);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/hooks/index.ts
var hooks = __webpack_require__(32345);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
;// CONCATENATED MODULE: ../assets/images/about-img-placeholder.png
/* harmony default export */ var about_img_placeholder = ({"src":"/_next/static/media/about-img-placeholder.91debf91.png","height":780,"width":900,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAABlBMVEXt7e3j4+McGFYMAAAACXBIWXMAACE4AAAhOAFFljFgAAAAHElEQVQImWNgQAKMjFAajMACcCGEAJgJ5jIyAAAB+AATiIzotAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../core/src/components/AboutUsCard.tsx





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-col\n  flex-1\n  w-[300px]\n  lg:w-[240px]\n  xl:w-[296px]\n  mx-auto\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  relative\n  flex\n  mb-3\n  rounded-lg\n  overflow-hidden\n  h-[260px]\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  absolute\n  w-full\n  h-full\n  z-20\n  bg-transparent\n  transition\n  duration-300\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "text-lg font-medium mb-1"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var Container = dist_default().div(_templateObject(), function(param) {
    var $hover = param.$hover;
    return $hover ? 'hover:cursor-pointer' : '';
});
var ImgContainer = dist_default().div(_templateObject1());
var Overlay = dist_default().div(_templateObject2(), function(param) {
    var $hover = param.$hover;
    return $hover ? 'hover:bg-gray-500/25' : '';
});
var Name = dist_default().p(_templateObject3());
var AboutUsCard = function(param) {
    var id = param.id, photoUrl = param.photoUrl, firstName = param.firstName, lastName = param.lastName, title = param.title, description = param.description, onClick = param.onClick;
    var t = (0,esm/* useTranslation */.$G)('enum').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        onClick: description ? function() {
            return onClick(id);
        } : undefined,
        $hover: !!description,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImgContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                        $hover: !!description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: photoUrl || about_img_placeholder,
                        objectFit: "cover",
                        layout: "fill",
                        unoptimized: !!photoUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                children: [
                    firstName,
                    " ",
                    lastName
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("RepresentativeTitle.".concat(title))
            })
        ]
    }));
};

// EXTERNAL MODULE: ../core/src/components/CloseButton.tsx
var CloseButton = __webpack_require__(97872);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
;// CONCATENATED MODULE: ../assets/icons/linkedin.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M27 0H5a5 5 0 0 0-5 5v22a5 5 0 0 0 5 5h22a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.6 24H8.2V13.3h3.4V24ZM9.9 11.8C8.8 11.8 8 11 8 9.9 8 8.8 8.9 8 9.9 8c1.1 0 1.9.8 1.9 1.9 0 1.1-.8 1.9-1.9 1.9ZM24 24h-3.4v-5.8c0-1.7-.7-2.2-1.7-2.2s-2 .8-2 2.3V24h-3.4V13.3h3.2v1.5c.3-.7 1.5-1.8 3.2-1.8 1.9 0 3.9 1.1 3.9 4.4V24h.2Z",
    fill: "#fff"
  })));
};

/* harmony default export */ var linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ../core/src/components/AboutUsList.tsx













function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AboutUsList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AboutUsList_templateObject() {
    var data = AboutUsList_taggedTemplateLiteral([
        "flex flex-1 flex-col w-screen"
    ]);
    AboutUsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboutUsList_templateObject1() {
    var data = AboutUsList_taggedTemplateLiteral([
        "container grid grid-flow-row grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 justify-center"
    ]);
    AboutUsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboutUsList_templateObject2() {
    var data = AboutUsList_taggedTemplateLiteral([
        "w-full bg-gray-200"
    ]);
    AboutUsList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboutUsList_templateObject3() {
    var data = AboutUsList_taggedTemplateLiteral([
        "flex flex-col lg:flex-row bg-gray-200 container py-11"
    ]);
    AboutUsList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = AboutUsList_taggedTemplateLiteral([
        "text-lg font-medium mb-1"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = AboutUsList_taggedTemplateLiteral([
        "text-gray-800 mr-2 lg:mr-auto"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var AboutUsList_Container = dist_default().div(AboutUsList_templateObject());
var PersonContainer = dist_default().div(AboutUsList_templateObject1());
var CollapseContainer = dist_default().div(AboutUsList_templateObject2());
var InfoContainer = dist_default().div(AboutUsList_templateObject3());
var AboutUsList_Name = dist_default().p(_templateObject4());
var Description = dist_default().div(_templateObject5());
var AboutUsList = (0,utils/* clientOnlyComponent */.V4)(function() {
    var t = (0,esm/* useTranslation */.$G)([
        'about',
        'enum'
    ]).t;
    var data = (0,generated/* useEmployeesQuery */.UQW)({
        fetchPolicy: 'cache-first'
    }).data;
    var employees = (0,react.useMemo)(function() {
        return (data === null || data === void 0 ? void 0 : data.countryRepresentatives.flatMap(function(param) {
            var representatives = param.representatives;
            return representatives;
        })) || [];
    }, [
        data
    ]);
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(null), activeItem = ref1[0], setActiveItem = ref1[1];
    var ref2 = (0,react.useState)(false), showMore = ref2[0], setShowMore = ref2[1];
    var ref3 = (0,hooks/* useDeviceMediaQuery */.mL)(), desktop = ref3.desktop, tablet = ref3.tablet;
    var openInfoBox = (0,react.useCallback)(function(id) {
        if (open) {
            if (id === activeItem) {
                setOpen(false);
            }
        } else {
            setOpen(true);
        }
        if (id !== activeItem) {
            setActiveItem(id);
        }
    }, [
        open,
        activeItem
    ]);
    var closeInfoBox = (0,react.useCallback)(function() {
        setOpen(false);
        setTimeout(function() {
            setActiveItem(null);
        }, 700);
    }, []);
    var items = (0,react.useMemo)(function() {
        return (0,utils/* arrayToChunks */.Se)(showMore ? employees : employees.slice(0, 8), desktop ? 4 : tablet ? 2 : 1);
    }, [
        desktop,
        tablet,
        showMore,
        employees
    ]);
    var currentPerson = (0,react.useMemo)(function() {
        return employees.find(function(param) {
            var id = param.id;
            return id === activeItem;
        });
    }, [
        activeItem,
        employees
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsList_Container, {
        children: [
            items.map(function(chunk, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonContainer, {
                            children: chunk.map(function(person) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AboutUsCard, _objectSpread({
                                    onClick: openInfoBox
                                }, person), person.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Collapse, {
                            theme: {
                                collapse: 'duration-700 my-6'
                            },
                            isOpened: open && !!chunk.find(function(param) {
                                var id = param.id;
                                return id === activeItem;
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoContainer, {
                                    children: desktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mr-24",
                                                children: [
                                                    currentPerson && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsList_Name, {
                                                        children: [
                                                            currentPerson.firstName,
                                                            " ",
                                                            currentPerson.lastName
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: currentPerson ? t("enum:RepresentativeTitle.".concat(currentPerson.title)) : null
                                                    }),
                                                    (currentPerson === null || currentPerson === void 0 ? void 0 : currentPerson.linkedinUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "mt-4 inline-block",
                                                        href: currentPerson.linkedinUrl,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                            src: linkedin,
                                                            size: 32
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                                className: "max-w-[625px] mr-auto",
                                                dangerouslySetInnerHTML: {
                                                    __html: (currentPerson === null || currentPerson === void 0 ? void 0 : currentPerson.description) || ''
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                                                onClick: closeInfoBox
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-1 justify-between mb-8",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            currentPerson && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutUsList_Name, {
                                                                children: [
                                                                    currentPerson.firstName,
                                                                    " ",
                                                                    currentPerson.lastName
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: currentPerson === null || currentPerson === void 0 ? void 0 : currentPerson.title
                                                            }),
                                                            (currentPerson === null || currentPerson === void 0 ? void 0 : currentPerson.linkedinUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "mt-4 inline-block",
                                                                href: currentPerson.linkedinUrl,
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                                    src: linkedin,
                                                                    size: 32
                                                                })
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                                                        className: "mr-1",
                                                        onClick: closeInfoBox
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                                dangerouslySetInnerHTML: {
                                                    __html: (currentPerson === null || currentPerson === void 0 ? void 0 : currentPerson.description) || ''
                                                }
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }, index);
            }),
            showMore ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                value: "about-us-load-more",
                title: t('loadMoreTeam'),
                outline: true,
                className: "self-center",
                onClick: function() {
                    return setShowMore(true);
                }
            })
        ]
    }));
});

// EXTERNAL MODULE: ../core/src/components/Navigation/NavBar.tsx + 7 modules
var NavBar = __webpack_require__(42234);
// EXTERNAL MODULE: ../core/src/components/Navigation/FooterLanding.tsx + 5 modules
var FooterLanding = __webpack_require__(56993);
// EXTERNAL MODULE: ../core/src/config/domains.js
var domains = __webpack_require__(2811);
var domains_default = /*#__PURE__*/__webpack_require__.n(domains);
// EXTERNAL MODULE: ../assets/videos/trees-about.mp4
var trees_about = __webpack_require__(98402);
var trees_about_default = /*#__PURE__*/__webpack_require__.n(trees_about);
;// CONCATENATED MODULE: ../assets/images/team-photo.png
/* harmony default export */ var team_photo = ({"src":"/_next/static/media/team-photo.6cd31e45.png","height":900,"width":939,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEX0+fSttqltaGWRlYQvNzvZ4+XByMqehHiIcmhfT0SalJ9nVk+Jj5VNWGCPhHt3hI+TnZ+Ii4i2s8Ln8vOWi3jL3dxwZFRjXl+dz716dnCnqqXKz8TW6d2zwLOim4+qq6qmsLZxeH7A1d9rPGJne4QGghaTAAAACXBIWXMAACE4AAAhOAFFljFgAAAARUlEQVQImQXBhQHAIBAEsEMfp1B33X/GJmArtqlXCs2CXQjWIhYc3nYaskCngThkQDN7MpD8TNaSwefqlUdDuN/65BjcD3FUA2lai/ZAAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/images/squirrel.png
/* harmony default export */ var squirrel = ({"src":"/_next/static/media/squirrel.839dea72.png","height":444,"width":444,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEU5LyhRTUSSdWFMPzRGSjZgVlErIByAeniRjI5bWUwiFhFEOzdoYVxfTECGhIOZlJZQNiVyaWWDfnS3sKs0IhlxUTqdmJx4YlR2cW2FL11fAAAACXBIWXMAACE4AAAhOAFFljFgAAAAQUlEQVQImR3GRxKAIBAAwQHZQFAw8/+XWmWfmpDQUt3ICUrtGzktK+J/4mluHEFHjL3RAtdtz0QEXXc3JKPj9fkBRLUCLeKVLRYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../assets/icons/iron-wolf-capital-logo.png
/* harmony default export */ var iron_wolf_capital_logo = ({"src":"/_next/static/media/iron-wolf-capital-logo.b5501a7e.png","height":453,"width":903,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEVMaXEFBf4EBP1lfvhJWfqjxfYKCv2Il/p7fP6yuP1tevtdZ/wmDQeZAAAADHRSTlMAQiMVRRBN2zDx6OwD/jYpAAAACXBIWXMAACE4AAAhOAFFljFgAAAAJUlEQVQImR3ExxEAMAgEsT2SU//9ekAPgTsj1w1JkOeFyoDdwQcGGgBUsi7toAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/icons/70-ventures-logo.png
/* harmony default export */ var _70_ventures_logo = ({"src":"/_next/static/media/70-ventures-logo.ba8440c0.png","height":114,"width":720,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEU3R1c2SFg3R1c5RVQ3R1cBpewUg7UApezhpuoSAAAACHRSTlMZLiNRQGh2kJtgJBIAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAaSURBVAiZY2BnZWZiYmBgYGBlY2ZkZGFkAQABuwAtyMTUGgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../assets/icons/coinvest-capital-logo.png
/* harmony default export */ var coinvest_capital_logo = ({"src":"/_next/static/media/coinvest-capital-logo.1c5c2de6.png","height":201,"width":759,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEUAAAAAAAAAAAAAAAAAAABPDueNAAAABXRSTlMqGyQZBG0rYrcAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAZSURBVAiZBcEBAQAACIMw4PbP7MZwRIhS9wDLABc+UtAXAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/pages/about-us.tsx














function about_us_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function about_us_templateObject() {
    var data = about_us_taggedTemplateLiteral([
        "flex flex-col"
    ]);
    about_us_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function about_us_templateObject1() {
    var data = about_us_taggedTemplateLiteral([
        "container py-12 md:py-16"
    ]);
    about_us_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function about_us_templateObject2() {
    var data = about_us_taggedTemplateLiteral([
        "relative bg-gray-200 w-screen h-[600px]"
    ]);
    about_us_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function about_us_templateObject3() {
    var data = about_us_taggedTemplateLiteral([
        "absolute h-full w-full object-cover top-0"
    ]);
    about_us_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function about_us_templateObject4() {
    var data = about_us_taggedTemplateLiteral([
        "\n  relative\n  top-0\n  w-full\n  h-full\n  container\n  items-center\n  justify-center\n  z-20\n"
    ]);
    about_us_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function about_us_templateObject5() {
    var data = about_us_taggedTemplateLiteral([
        "absolute top-0 bottom-0 left-0 right-0 bg-black z-10 opacity-25"
    ]);
    about_us_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = about_us_taggedTemplateLiteral([
        "text-base md:text-lg leading-6 md:leading-7 text-center lg:max-w-[850px]"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = about_us_taggedTemplateLiteral([
        "text-3xl md:text-4xl mb-8 font-semibold"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = about_us_taggedTemplateLiteral([
        "text-center"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = about_us_taggedTemplateLiteral([
        "items-center text-center mb-6 lg:mb-10"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = about_us_taggedTemplateLiteral([
        "\n  rounded-lg\n  bg-[#F8F6F3]\n  relative\n  flex\n  h-auto\n  md:min-h-[300px]\n  overflow-hidden\n  items-center\n  lg:max-w-[1064px]\n  lg:self-center\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = about_us_taggedTemplateLiteral([
        "text-gray-800"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = about_us_taggedTemplateLiteral([
        "\n  border-top-left-radius: 50%;\n  border-bottom-left-radius: 50%;\n  overflow: hidden;\n  margin-right: -70px;\n  height: 400px;\n  width: 400px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = about_us_taggedTemplateLiteral([
        "relative mr-10 w-[144px] h-[144px]"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = about_us_taggedTemplateLiteral([
        "\n  absolute\n  w-full\n  h-full\n  rounded-full\n  border-dashed\n  border-2\n  top-2\n  left-2\n  border-secondary-500\n  bg-transparent\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = about_us_taggedTemplateLiteral([
        "w-screen bg-[#F8F6F3]"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = about_us_taggedTemplateLiteral([
        "\n  md:flex-row\n  self-stretch\n  justify-between\n  items-center\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
var Col = dist_default().div(about_us_templateObject());
var about_us_Container = dist_default()(Col)(about_us_templateObject1());
var VideoContainer = dist_default().div(about_us_templateObject2());
var Video = dist_default().video(about_us_templateObject3());
var VideoTitleContainer = dist_default()(Col)(about_us_templateObject4());
var about_us_Overlay = dist_default().div(about_us_templateObject5());
var Text = dist_default().p(_templateObject6());
var JoinTitle = dist_default().span(_templateObject7());
var Title = dist_default()(JoinTitle)(_templateObject8());
var TeamDescContainer = dist_default()(Col)(_templateObject9());
// Fire Laurynas for not updating style guide :D
var JoinContainer = dist_default().div(_templateObject10());
var InfoText = dist_default().p(_templateObject11());
var TeamImgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a2dbad5a-0"
})(_templateObject12());
var RoundImgContainer = dist_default().div(_templateObject13());
var Circle = dist_default().div(_templateObject14());
var InvestBlock = dist_default().div(_templateObject15());
var InvestImgContainer = dist_default()(Col)(_templateObject16());
var email = (domains_default()).current.contacts.email;
var __N_SSG = true;
function AboutUs() {
    var t = (0,esm/* useTranslation */.$G)('about').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: t('pageTitle')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* NavBar */.l, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(about_us_Overlay, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                                autoPlay: true,
                                loop: true,
                                muted: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: (trees_about_default()),
                                    type: "video/mp4"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoTitleContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        className: "text-white",
                                        children: t('videoTitle')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        className: "text-white text-medium",
                                        children: t('videoText')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(about_us_Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TeamDescContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    className: "text-black",
                                    children: t('teamTitle')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                    className: "text-gray-800 ",
                                    children: [
                                        t('teamText'),
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsList, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(about_us_Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(JoinContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col, {
                                    className: "px-11 py-11 flex-1 items-center md:items-start text-center md:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinTitle, {
                                            className: "mb-2",
                                            children: t('growWithUsTitle')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoText, {
                                            className: "mb-8",
                                            children: [
                                                t('growWithUsText'),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(email),
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                title: t('joinTheTeam'),
                                                value: "join-the-team",
                                                className: "self-center md:self-start"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoundImgContainer, {
                                    className: "hidden lg:block",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: squirrel,
                                            className: "rounded-full"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamImgContainer, {
                                    className: "hidden md:flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: team_photo
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestBlock, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(about_us_Container, {
                            className: "items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    className: "text-gray-800",
                                    children: t('ourInvestorsTitle')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    className: "text-gray-800 text-center mb-8 lg:mb-10",
                                    children: t('investorText')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestImgContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[245px] lg:w-[301px] mb-5 md:mb-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: iron_wolf_capital_logo
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[195px] lg:w-[240px] mb-11 md:mb-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: _70_ventures_logo
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[218px] lg:w-[253px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: coinvest_capital_logo
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLanding/* FooterLanding */.m, {})
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 56993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ FooterLanding; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/components/Navigation/NavLink.tsx
var NavLink = __webpack_require__(72499);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
// EXTERNAL MODULE: ../assets/icons/foros-logo-white.svg
var foros_logo_white = __webpack_require__(46127);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../assets/icons/facebook.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 13 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.423 27V14.732h3.845l.57-4.79H8.422V6.904c0-1.4.366-2.34 2.217-2.34H13V.3A27.22 27.22 0 0 0 9.541.015a5.012 5.012 0 0 0-2.308.37A5.342 5.342 0 0 0 5.29 1.779a5.847 5.847 0 0 0-1.206 2.148 6.16 6.16 0 0 0-.24 2.496v3.52H0v4.79h3.845V27h4.578Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var facebook = (SvgFacebook);
;// CONCATENATED MODULE: ../assets/icons/linked-in.svg
var linked_in_path;

function linked_in_extends() { linked_in_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linked_in_extends.apply(this, arguments); }



var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/react.createElement("svg", linked_in_extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), linked_in_path || (linked_in_path = /*#__PURE__*/react.createElement("path", {
    d: "M.451 8.981h5.637V27H.45V8.981ZM3.27 0a3.264 3.264 0 0 1 3.023 2.029 3.283 3.283 0 0 1-.721 3.574 3.267 3.267 0 0 1-5.57-2.355C0 2.387.34 1.56.948.95A3.238 3.238 0 0 1 3.241 0h.028Zm6.285 27h5.637v-8.896c0-2.373.451-4.632 3.354-4.632s2.818 2.683 2.818 4.773V27H27v-9.885c0-4.858-1.071-8.473-6.708-8.473a5.852 5.852 0 0 0-5.298 2.825V8.98H9.639L9.554 27Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var linked_in = (SvgLinkedIn);
;// CONCATENATED MODULE: ../assets/icons/instagram.svg
var instagram_path;

function instagram_extends() { instagram_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_extends.apply(this, arguments); }



var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/react.createElement("svg", instagram_extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), instagram_path || (instagram_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a3 3 0 0 1 3-3h19.773a3 3 0 0 1 3 3v21a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm22.09 2.523a1.84 1.84 0 1 1-3.681 0 1.84 1.84 0 0 1 3.682 0ZM9 8.48a6.316 6.316 0 0 1 3.58-1.117c1.71 0 3.348.699 4.556 1.942a6.725 6.725 0 0 1 1.887 4.686c0 1.31-.377 2.592-1.085 3.682a6.486 6.486 0 0 1-2.892 2.44 6.277 6.277 0 0 1-3.723.378 6.39 6.39 0 0 1-3.299-1.814 6.688 6.688 0 0 1-1.763-3.393 6.803 6.803 0 0 1 .367-3.83A6.59 6.59 0 0 1 9 8.48Zm1.194 9.184a4.211 4.211 0 0 0 2.386.745c1.14 0 2.232-.466 3.038-1.294a4.483 4.483 0 0 0 1.258-3.124c0-.874-.252-1.728-.724-2.455a4.324 4.324 0 0 0-1.928-1.627 4.185 4.185 0 0 0-2.482-.252 4.26 4.26 0 0 0-2.2 1.21 4.459 4.459 0 0 0-1.175 2.262 4.536 4.536 0 0 0 .245 2.553 4.394 4.394 0 0 0 1.582 1.982Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var instagram = (SvgInstagram);
;// CONCATENATED MODULE: ../assets/icons/youtube.svg
var youtube_path;

function youtube_extends() { youtube_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return youtube_extends.apply(this, arguments); }



var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/react.createElement("svg", youtube_extends({
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), youtube_path || (youtube_path = /*#__PURE__*/react.createElement("path", {
    d: "M33.23 0H6.77a6.732 6.732 0 0 0-4.787 2.005A6.883 6.883 0 0 0 0 6.845v14.31c0 1.816.713 3.557 1.983 4.84A6.732 6.732 0 0 0 6.769 28h26.462a6.731 6.731 0 0 0 4.786-2.005A6.883 6.883 0 0 0 40 21.155V6.846a6.883 6.883 0 0 0-1.983-4.84A6.731 6.731 0 0 0 33.231 0Zm-5.396 14.274-12 6.222a.304.304 0 0 1-.409-.122.313.313 0 0 1-.04-.152V7.778a.313.313 0 0 1 .149-.264.305.305 0 0 1 .3-.01l12 6.222a.31.31 0 0 1 .167.277.314.314 0 0 1-.167.277v-.006Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var youtube = (SvgYoutube);
;// CONCATENATED MODULE: ../assets/images/climate-acc.jpg
/* harmony default export */ var climate_acc = ({"src":"/_next/static/media/climate-acc.39cfc554.jpg","height":3700,"width":16320,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAACAwEBAQAAAAAAAAAAAAABAgADBBEFIf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQMxQf/aAAwDAQACEQMRAD8AolmejF43otkprzsFY9qUIehTw/IiIuPQ7pH/2Q=="});
;// CONCATENATED MODULE: ../core/src/components/Navigation/FooterLanding.tsx














function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-col"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "container py-9 md:py-16 md:flex-row gap-3"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex flex-1 flex-col-reverse gap-10 xl:flex-row"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "hidden md:flex space-x-8"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "flex mr-auto mb-10 md:mb-0"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "text-gray-400 mb-5"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  relative\n  flex\n  flex-1\n  md:self-end\n  xl:self-start\n  max-w-[400px]\n  min-h-[92px]\n  md:min-h-[80px]\n  xl:min-h-[92px]\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
var Column = dist_default().div(_templateObject());
var Container = dist_default()(Column)(_templateObject1());
var LinksContainer = dist_default().div(_templateObject2());
var IconContainer = dist_default().div(_templateObject3());
var Line = dist_default().div(_templateObject4());
var CredentialText = dist_default().p(_templateObject5());
var FooterLink = (0,styled_components_browser_esm/* default */.ZP)(NavLink/* NavLink */.O).withConfig({
    componentId: "sc-ae8a30eb-0"
})(_templateObject6(), (theme_default()).colors.gray[400]);
var ClimateImgContainer = dist_default().div(_templateObject7());
var FooterLanding = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-primary-500",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinksContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                            className: "mr-12 md:mr-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                    src: foros_logo_white/* default */.Z,
                                    width: 82,
                                    height: 20,
                                    className: "mb-7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CredentialText, {
                                    children: t('copyright')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CredentialText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            className: "underline",
                                            href: "/rules",
                                            children: t('nav.rules')
                                        }),
                                        "\xa0•\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            className: "underline",
                                            href: "/privacy-policy",
                                            children: t('nav.privacyPolicy')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.linkedin.com/company/foros-platform/",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: linked_in,
                                                size: 27
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.facebook.com/ForosLT",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: facebook,
                                                width: 13,
                                                height: 27
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.youtube.com/channel/UCKWsYIaiMQbsgW4Fle3uxcg",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: youtube,
                                                width: 40,
                                                height: 28
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.instagram.com/forosplatform/",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: instagram,
                                                width: 26,
                                                height: 27
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                                    className: "space-y-2 mr-9",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            href: "/auctions",
                                            children: t('nav.auctions')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            href: "/about-us",
                                            children: t('nav.aboutUs')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            href: "/contact-us",
                                            children: t('nav.contactUs')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                                    className: "space-y-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                        href: "/press",
                                        children: t('nav.pressRoom')
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClimateImgContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: climate_acc,
                        className: "w-full h-full",
                        objectFit: "contain",
                        objectPosition: "top",
                        layout: "fill"
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 69293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Collapse = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "timeout", undefined);

    _defineProperty(_assertThisInitialized(_this), "container", undefined);

    _defineProperty(_assertThisInitialized(_this), "content", undefined);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      clearTimeout(_this.timeout);

      if (!_this.container || !_this.content) {
        return;
      }

      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          checkTimeout = _this$props.checkTimeout;
      var containerHeight = Math.floor(_this.container.clientHeight);
      var contentHeight = Math.floor(_this.content.clientHeight);
      var isFullyOpened = isOpened && Math.abs(contentHeight - containerHeight) <= 1;
      var isFullyClosed = !isOpened && Math.abs(containerHeight) <= 1;

      if (isFullyOpened || isFullyClosed) {
        _this.onRest({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      } else {
        _this.onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });

        _this.timeout = setTimeout(function () {
          return _this.onResize();
        }, checkTimeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref) {
      var isFullyOpened = _ref.isFullyOpened,
          isFullyClosed = _ref.isFullyClosed,
          isOpened = _ref.isOpened,
          containerHeight = _ref.containerHeight,
          contentHeight = _ref.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var hasOpened = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var hasClosed = !isOpened && _this.container.style.height === '0px';

      if (hasOpened || hasClosed) {
        _this.container.style.overflow = isOpened ? 'initial' : 'hidden';
        _this.container.style.height = isOpened ? 'auto' : '0px';
        var onRest = _this.props.onRest;

        if (onRest) {
          onRest({
            isFullyOpened: isFullyOpened,
            isFullyClosed: isFullyClosed,
            isOpened: isOpened,
            containerHeight: containerHeight,
            contentHeight: contentHeight
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref2) {
      var isFullyOpened = _ref2.isFullyOpened,
          isFullyClosed = _ref2.isFullyClosed,
          isOpened = _ref2.isOpened,
          containerHeight = _ref2.containerHeight,
          contentHeight = _ref2.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var isOpenining = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var isClosing = !isOpened && _this.container.style.height === '0px';

      if (isOpenining || isClosing) {
        // No need to do any work
        return;
      }

      _this.container.style.overflow = 'hidden';
      _this.container.style.height = isOpened ? "".concat(contentHeight, "px") : '0px';
      var onWork = _this.props.onWork;

      if (onWork) {
        onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContainer", function (container) {
      _this.container = container;
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContent", function (content) {
      _this.content = content;
    });

    if (props.initialStyle) {
      _this.initialStyle = props.initialStyle;
    } else {
      _this.initialStyle = props.isOpened ? {
        height: 'auto',
        overflow: 'initial'
      } : {
        height: '0px',
        overflow: 'hidden'
      };
    }

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          isOpened = _this$props2.isOpened,
          children = _this$props2.children;
      return children !== nextProps.children || isOpened !== nextProps.isOpened || Object.keys(theme).some(function (c) {
        return theme[c] !== nextProps.theme[c];
      });
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      if (!this.container || !this.content) {
        return null;
      }

      if (this.container.style.height === 'auto') {
        var contentHeight = this.content.clientHeight;
        this.container.style.height = "".concat(contentHeight, "px");
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          theme = _this$props3.theme,
          children = _this$props3.children,
          isOpened = _this$props3.isOpened;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContainer,
        className: theme.collapse,
        style: this.initialStyle,
        "aria-hidden": !isOpened
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContent,
        className: theme.content
      }, children));
    }
  }]);

  return Collapse;
}(_react["default"].Component);

exports.Collapse = Collapse;

_defineProperty(Collapse, "defaultProps", {
  theme: {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
  },
  initialStyle: undefined,
  onRest: undefined,
  onWork: undefined,
  checkTimeout: 50
});

/***/ }),

/***/ 352:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UnmountClosed = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _Collapse = __webpack_require__(69293);

var _excluded = ["isOpened"],
    _excluded2 = ["isOpened"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnmountClosed = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  var _super = _createSuper(UnmountClosed);

  function UnmountClosed(props) {
    var _this;

    _classCallCheck(this, UnmountClosed);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref) {
      var isOpened = _ref.isOpened,
          rest = _objectWithoutProperties(_ref, _excluded);

      _this.setState({
        isResting: false,
        isOpened: isOpened
      });

      var onWork = _this.props.onWork;

      if (onWork) {
        onWork(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref2) {
      var isOpened = _ref2.isOpened,
          rest = _objectWithoutProperties(_ref2, _excluded2);

      _this.setState({
        isResting: true,
        isOpened: isOpened,
        isInitialRender: false
      });

      var onRest = _this.props.onRest;

      if (onRest) {
        onRest(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialStyle", function () {
      var _this$state = _this.state,
          isOpened = _this$state.isOpened,
          isInitialRender = _this$state.isInitialRender;

      if (isInitialRender) {
        return isOpened ? {
          height: 'auto',
          overflow: 'initial'
        } : {
          height: '0px',
          overflow: 'hidden'
        };
      }

      return {
        height: '0px',
        overflow: 'hidden'
      };
    });

    _this.state = {
      isResting: true,
      isOpened: props.isOpened,
      isInitialRender: true
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpened = this.props.isOpened;

      if (prevProps.isOpened !== isOpened) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isResting: false,
          isOpened: isOpened,
          isInitialRender: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isResting = _this$state2.isResting,
          isOpened = _this$state2.isOpened;
      return isResting && !isOpened ? null : /*#__PURE__*/_react["default"].createElement(_Collapse.Collapse, _extends({}, this.props, {
        initialStyle: this.getInitialStyle(),
        onWork: this.onWork,
        onRest: this.onRest
      }));
    }
  }]);

  return UnmountClosed;
}(_react["default"].PureComponent);

exports.UnmountClosed = UnmountClosed;

_defineProperty(UnmountClosed, "defaultProps", {
  onWork: undefined,
  onRest: undefined
});

/***/ }),

/***/ 98452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(69293),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__(352),
    UnmountClosed = _require2.UnmountClosed; // Default export


module.exports = UnmountClosed; // Extra "named exports"

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7362,1433,3442,2234,9774,2888,179], function() { return __webpack_exec__(2802); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);